import { render, staticRenderFns } from "./ManageSchoolSection.vue?vue&type=template&id=61a3aa0e&"
import script from "./ManageSchoolSection.vue?vue&type=script&lang=js&"
export * from "./ManageSchoolSection.vue?vue&type=script&lang=js&"
import style0 from "./ManageSchoolSection.vue?vue&type=style&index=0&id=61a3aa0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports